import React, { useState } from "react";
import "./Service.scss";
import TopCard from "../../components/serviceSessions/topCard/TopCard";
import ServiceList from "../../components/serviceSessions/serviceList/ServiceList";
import TopView from "../../components/serviceSessions/topView/TopView";
import Slider from "../../components/serviceSessions/slider/Slider";
import TopButton from "../../components/serviceSessions/topButton/TopButton";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
<Breadcrumb />
export default function Service({ data }) {
  console.log("data", data);
  const [showSpring, setShowSpring] = useState(false);

  const renderLocationContent = (location) => {
    const currentData = data[location];

    return (
      <div
        key={location}
        style={{ display: location === "spring" ? (showSpring ? "block" : "none") : showSpring ? "none" : "block" }}
      >
        <TopView
          heroImg={currentData.heroImg}
          title={currentData.title}
          desp={currentData.desp}
        />
        <TopCard
          cardImg={currentData.cardImg}
          title={currentData.title}
          txt1={currentData.cardTxt1}
          txt2={currentData.cardTxt2}
        />
        <ServiceList data={currentData.services} />
        <Slider data={currentData.portfolio} />
      </div>
    );
  };

  return (
    <div>
      <TopButton setShowSpring={setShowSpring} showSpring={showSpring} />
      {renderLocationContent("houston")}
      {renderLocationContent("spring")}
    </div>
  );
}
